<script>
import PageTracker from "../Data/Store/PageTracker";

export default {
    methods: {
        getRouteParameter(parameter) {
            return this.$route.params[parameter];
        },

        trackRouteName(routeName) {
            let Tracker = new PageTracker();
            Tracker.setPrevious(routeName);
        }
    },

    beforeRouteLeave(to, from, next) {
        this.trackRouteName(from.name);
        next();
    }
}
</script>